
import { useQuery } from '@tanstack/react-query';
import { getTenantConfig } from '@/services/tenants';

export const useTenantConfig = (siteType: string | null) => {
  return useQuery({
    queryKey: ['tenantConfig', siteType],
    queryFn: () => getTenantConfig(siteType!),
    enabled: !!siteType && siteType.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
